export const environment = {
  production: true,
  buildId: '3744012073923271',
  configFile: 'config.json',
};
